<!--
 * @FilePath: table.vue
 * @Author: Aron
 * @Date: 2023-07-21 11:42:50
 * @LastEditors: hushun hushun@songshuai.com
 * @LastEditTime: 2025-08-06 16:49:08
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
-->
<template>
  <div>
    <el-popover
      style="float:right"
      v-if="selectTitle"
      placement="bottom"
      trigger="hover"
      class="popover"
      @show="showPopover"
    >
      <div
        style="display: flex; justify-content: space-between;align-items: center;"
      >
        <el-checkbox v-model="checkAll" @change="checkAllChangeFn"
          >全选</el-checkbox
        >
        <el-button type="text" @click="reset(true)">重置</el-button>
      </div>
      <el-checkbox-group
        class="selectTitle"
        v-model="checkColumns"
        @change="changeColumns"
      >
        <el-checkbox
          v-for="item in titleData"
          :key="item.prop"
          :label="item.label"
          :disabled="item.fixed == 'left' ? true : false"
        ></el-checkbox>
      </el-checkbox-group>
      <i class="el-icon-s-tools" slot="reference"></i>
    </el-popover>
    <el-table
      ref="table"
      :data="tableData"
      :show-summary="summary"
      :summary-method="summary ? summaryMethod : null"
      :row-class-name="rowClassName?rowClassName:null"
      @filter-change="filterMethod"
      :max-height="maxHeight"
      :header-cell-style="{
        background: 'rgb(230, 240, 252)',
        textAlign: 'center',
        color: 'black'
      }"
      :cell-style="{
        textAlign: 'center',
        padding: '0'
      }"
      @sort-change="(data) => $emit('sortChange', data)"
      @selection-change="handleSelectionChange"
      @clear-selection="handleClearSelection"
      v-loading="loading" 
    >
      <template slot="empty">
        <el-empty :image-size="70"></el-empty>
      </template>
      <el-table-column
        v-if="index"
        type="index"
        label="序号"
        :index="indexMethod"
      >
      </el-table-column>
      <el-table-column v-if="checkbox" type="selection" width="55">
      </el-table-column>
      <!-- 数据区 -->
      <template v-for="item in titleData">
        <!-- 正常显示 -->
        <!-- 换行样式处理 -->
        <!-- <el-table-column>
          {{ item.type  }}type
        </el-table-column> -->
        <el-table-column v-if="item.type=='lineFlag'" :prop="item.prop" :label="item.label" :width="item.width">
          <template slot-scope="scope">
           1 <div v-html="scope.row[item.prop]"></div>
          </template>
        </el-table-column>
        <el-table-column v-if="item.type=='ellipsis'" :prop="item.prop" :label="item.label" :width="item.width">
          <template slot-scope="scope">
            <div class="ellipsis-wrap" v-html="scope.row[item.prop] || '-'"></div>
          </template>
        </el-table-column>
        <el-table-column v-if="item.type==='formatter'" :prop="item.prop" :label="item.label" :width="item.width" :key="item.prop">
          <template slot-scope="scope">
            <div class="ellipsis-wrap">{{item.formatter(scope.row[item.prop]) || '-'}}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!item.type && showColumn(item.prop)"
          :fixed="item.fixed ? item.fixed : false"
          :label="item.label"
          :min-width="item.width"
          :key="item.key"
          :prop="item.prop"
          :sortable="item.sortable"
          :empty-text="item.emptyText ? item.emptyText : '-'"
          style=""
          column-key="item.prop"
          :filters="item.filters ? item.filters : null"
          :style="{ 'background-color': 'rgb(207, 241, 242)' }"
          :class-name="item.wrap ? 'custom-cell' : null"
          :show-overflow-tooltip="item.showOverflowTooltip"
        >
          <!-- {{ item }} -->
          <template slot="header" v-if="item.hasPopover">
            <el-popover
              placement="bottom"
              title=""
              width="200"
              trigger="hover"
              popper-class="info-popover"
              content="账号创建后，账号的状态是“待确认”，“待确认”的账号无法登录。创建的同时员工会收到总部钉钉加入的邀请，下载并打开钉钉，接受邀请加入总部后，账号就会从“待确认”变为“正常”状态，即可登录系统。"
            >
              <div class="" slot="reference">
                {{ item.label
                }}<i class="margin-left el-icon-warning-outline"></i>
              </div>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <template>
              <span :class="[
                {
                  'highlight-text-with-red': item.prop == 'accountNum' && scope.row.accountNum > scope.row.maxBindAccountNum
                }
              ]">
                {{
                  scope.row[item.prop] === 0
                    ? 0
                    : scope.row[item.prop] === ""
                    ? "-"
                    : scope.row[item.prop] !== null
                    ? scope.row[item.prop]
                    : "-"
                }}
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          v-if="item.type == 'tooltip' && showColumn(item.prop)"
          :fixed="item.fixed ? item.fixed : false"
          :label="item.label"
          :width="item.width"
          :key="item.key"
          :empty-text="item.emptyText ? item.emptyText : '-'"
        >
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              placement="top-start"
              v-if="item.prop === 'districts'"
              :disabled="
                scope.row.districts && scope.row.districts.length > 1
                  ? false
                  : true
              "
            >
              <!-- 必须把文字装在容器里面 -->
              <template>
                <div
                  slot="content"
                  style="width:250px"
                  class="districtsTooltip"
                >
                  {{ scope.row.districts && scope.row.districts.join("，") }}
                </div>
              </template>
              <p
                :style="{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }"
                >
                {{(scope.row.districts && scope.row.districts[0]) || "-"}}
                <!-- <span>
                  <span>{{
                    (scope.row.districts && scope.row.districts[0]) || "-"
                  }}</span>
                </span>
                <span
                  :style="{
                    marginLeft: '5px',
                    color: '#4A83E8',
                    flexShrink: 0
                  }"
                  v-if="
                    scope.row.districts && scope.row.districts.length > 1
                      ? true
                      : false
                  "
                  >更多</span
                > -->
              </p>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              placement="top-start"
              v-else-if="item.prop === 'districtsStr'"
              :disabled="
                scope.row.districtsStr && scope.row.districtsStr.length > 1
                  ? false
                  : true
              "
            >
              <!-- 必须把文字装在容器里面 -->
              <template>
                <div
                  slot="content"
                  style="width:250px"
                  class="districtsTooltip"
                >
                  {{ scope.row.districtsStr }}
                </div>
              </template>
              <p
                :style="{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }"
                >
                {{scope.row.districtsStr || "-"}}
                <!-- <span>
                  <span style="overflow: hidden;white-space: nowrap">{{
                    scope.row.districtsStr || "-"
                  }}</span>
                </span> -->
                <!-- <span
                  :style="{
                    marginLeft: '5px',
                    color: '#4A83E8',
                    flexShrink: 0
                  }"
                  v-if="
                    scope.row.districtsStr && scope.row.districtsStr.length > 1
                      ? true
                      : false
                  "
                  >更多</span
                > -->
              </p>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              placement="top-start"
              :content="scope.row.trueName"
              v-else-if="item.prop === 'trueName'"
            >
              <!-- 必须把文字装在容器里面 -->
              <span>
                <em
                  :style="scope.row.headmaster === true ? markStyle : nullStyle"
                >
                  主
                </em>
                {{ scope.row.trueName || "-" }}
              </span>
            </el-tooltip>
            <template v-else-if="item.prop === 'mobile'">
              <template v-if="scope.row.mobile == ''">
                <span v-if="scope.row.id === uerInfo.id">
                  <el-tooltip
                    effect="dark"
                    placement="top-start"
                    content="绑定手机号后，可使用该手机号登录系统及找回密码"
                  >
                    <span @click="bindMobile"
                      >未绑定
                      <i
                        class="el-icon-mobile-phone"
                        :style="{ color: '#4A83E8' }"
                      ></i
                    ></span>
                  </el-tooltip>
                </span>
                <span v-else>未绑定</span>
              </template>
              <template v-else>
                <el-popover
                  placement="top-start"
                  trigger="click"
                  v-model="showPhoneValChicks"
                  :content="phoneValChicks"
                  @show="onVisibleChangeFun(scope.row)"
                >
                  <el-button
                    slot="reference"
                    type="text"
                    style="color:#606266"
                    >{{
                      scope.row.mobile?.replace(
                        /^(\d{3})\d{4}(\d{4})$/,
                        "$1****$2"
                      ) || "-"
                    }}</el-button
                  >
                </el-popover>
              </template>
            </template>
            <el-tooltip
              placement="top-start"
              :open-delay="300"
              effect="dark"
               v-else-if="item.prop === 'rightBaseOnlyRemark'"
            >
              <div
                slot="content"
                style="max-width: 800px; max-height: 160px; overflow:auto;"
              >
                <p>{{ scope.row[item.prop] || "-" }}</p>
              </div>
              <div
                class="ellipsis-wrap"
                v-html="scope.row[item.prop] || '-'"
              ></div>
            </el-tooltip>
            <el-tooltip
              placement="top-start"
              :open-delay="300"
              effect="dark"
              v-else
            >
              <div
                slot="content"
                style="max-width: 800px; max-height: 160px; overflow:auto;"
              >
                <p>{{ scope.row[item.prop] || "-" }}</p>
                <!-- <span
                  style="background: #fff;color: #333;padding: 1px 4px;border-radius: 2px;cursor: pointer;"
                  @click="changeSnCopy(scope.row[item.prop])"
                  >复制</span
                > -->
              </div>
              <div
                style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
                v-html="scope.row[item.prop] || '-'"
              ></div>
            </el-tooltip>

            <!-- <el-tooltip
              effect="dark"
              placement="top-start"
              :content="scope.row[item.prop]"
              v-else
            >
              <span
                :style="{
                  width: '120px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }"
                v-html="scope.row[item.prop]"
              ></span>
            </el-tooltip> -->
          </template>
        </el-table-column>
        <template v-if="item.type == 'slot'">
          <slot :name="item.prop"></slot>
        </template>
        <el-table-column
          v-if="item.type == 'text' && showColumn(item.prop)"
          :fixed="item.fixed ? item.fixed : false"
          :label="item.label"
          :width="item.width"
          :key="item.key"
          :empty-text="item.emptyText ? item.emptyText : '-'"
        >
          <template slot-scope="scope">
            <!-- text 这里必须配置prop==什么，否则显示不出来 -->
            <template v-if="item.prop == 'createBy'">
              {{
                scope.row.recharge_way === "ORDER_TYPE_GIVE"
                  ? "统筹部"
                  : scope.row.createBy || "-"
              }}
            </template>
            <template v-if="item.prop == 'rechargeAmount'">
              {{
                scope.row.recharge_way === "ORDER_TYPE_GIVE"
                  ? scope.row.hours + "课时"
                  : scope.row.rechargeAmount || "-"
              }}
            </template>
            <template v-if="item.prop == 'files'">
              <template v-if="scope.row.fileUrl?.length > 0">
                <span
                  class="btn-text"
                  @click="handlePreviewOne(scope.row.fileUrl)"
                >
                  查看
                </span>
              </template>
              <template v-else-if="item.rowName&&scope.row[item.rowName]?.length > 0">
                <span
                  class="btn-text"
                  @click="handlePreviewOne(scope.row[item.rowName])"
                >
                  查看
                </span>
              </template>
              <template v-else>
                查看
              </template>
            </template>
            <template v-if="item.prop == 'status'">
              <span :style="scope.row.status === 0 ? null : redStyle">
                {{ scope.row.status === 0 ? "正常" : "禁用" }}
              </span>
            </template>
            <template v-if="item.prop == 'statusName'">
              <span :style="scope.row.statusName === '禁用' ? redStyle : null">
                {{ scope.row.statusName || "正常" }}
              </span>
            </template>
            <template v-if="item.prop == 'createTime'">
              {{ timeFormat(scope.row.createTime) || "-" }}
            </template>
          </template>
        </el-table-column>
        <!-- 鼠标点击事件 -->
        <el-table-column
          v-if="item.type == 'colorText'"
          :fixed="item.fixed ? item.fixed : false"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :key="item.key"
          :sortable="item.sortable"
          :empty-text="item.emptyText ? item.emptyText : '-'"
          ><template slot-scope="scope">
            <template v-if="!item.noUrl">
              <span
                class="rowName"
                @click="
                  cellClick(item.url, scope.row[item.prop], item, scope.row)
                "
                >{{ scope.row[item.prop] || "-" }}</span
              ></template
            >
            <template v-else>
              <span style="color:rgb(24, 144, 255)">{{
                scope.row[item.prop] || "-"
              }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          v-if="item.type == 'count'"
          :fixed="item.fixed ? item.fixed : false"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :key="item.key"
          :empty-text="item.emptyText ? item.emptyText : '-'"
          :style="{ 'background-color': 'rgb(207, 241, 242)' }"
        >
          <template slot-scope="scope">
            <el-input-number
              :min="0"
              :max="maxNumber"
              :disabled="item.disabled && type == '3'"
              v-model="scope.row[item.prop]"
              @change="handleChangeNum"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          v-if="item.type == 'icon'"
          :fixed="item.fixed ? item.fixed : false"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :key="item.key"
          :empty-text="item.emptyText ? item.emptyText : '-'"
        >
          <template slot-scope="scope">
           <span v-if="scope.row.isTop" :class="[{
            'hot': scope.row.title
           }]">置顶</span>{{ scope.row.title }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="item.type == 'labelIcon'"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :key="item.key"
        >
         <template slot="header">
          <span >{{item.label}}</span>
          <span @click="handleDialog"  class="icon-kecheng"></span>
        </template>
        </el-table-column>
      </template>
      <!-- 操作区 整个作为插槽插入-->
      <slot> </slot>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size.sync="pageSize"
      :layout="layout || defaultLayout"
      :total="total"
      v-if="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import pubsub from "pubsub-js";
import { getUserMobileById } from "@/api/AccountSetting";
import { timeFormat ,trackEvent} from "@/util/util.js";
export default {
  name: "MyTable",
  // 表格基本使用(titleData每个值)：传递prop, label, width, fixed, emptyText
  // 因表格中不同行的样式不同，所以设置属性style，规定不同样式
  /*
    type值:
        不传 正常样式
        tooltip 鼠标hover需显示具体内容
        colorTetxt 改变一列的字体颜色颜色
        url 跳转路由的路径 /main/PurchaseCreation
        text 显示指定内容
        count 表格为计数框
        disabled 计数框禁用  只有当url中type=3禁止使用
  */
  /**
   *
   * 给table的值
   *      title表头数据
   *      tableData 表格数据
   *      totalCount 分页-数据总长度
   *      checkbox(为空  true) 是否为多选表格
   *      index 是否需要索引
   *      indexMethod 索引规则(默认索引从0开始)
   */
  /*
   *路由传参的值
   *      jump:是否跳转路由 跳转:true 打开新页面：false
   *      jump_param:跳转路由携带params参数, 数组 每一个值表示当前行的某个值的key值
   *
   */
  props: [
    "titleData",
    "tableData",
    "totalCount",
    "fileName",
    "checkbox",
    "index",
    "indexMethod",
    "uerInfo",
    "needData",
    "summary",
    "summaryMethod",
    "mobileJustShow", // 阻止点击手机号莫名其妙请求
    "selectTitle",
    "rowClassName",
    "maxNumber", // 数量上限值
    'maxHeight',
    'layout',
    'loading',
    'changePageSize',
    'changePageCurrent',
  ],
  data() {
    return {
      defaultLayout:'total, prev, pager, next, sizes,jumper',
      currentPage: 1,
      pageSize: 10,
      pubId1: null,
      pubId2: null,
      multipleSelection: [],
      markStyle: {
        width: "20px",
        height: "20px",
        background: "#ff4a46",
        borderRadius: "50em",
        fontSize: "12px",
        color: "#fff",
        lineHeight: "20px",
        fontStyle: "normal",
        display: "inline-block",
        marginRight: "5px",
        position: "relative",
        top: "-2px"
      },
      nullStyle: {
        display: "none"
      },
      redStyle: {
        color: "#ff4a46"
      },
      phoneValChicks: "",
      showPhoneValChicks: false,
      type: this.$route.query.type,
      checkAll: false,
      checkColumns: []
    };
  },
  methods: {
    // 全选复选框事件监听
    checkAllChangeFn(val) {
      if (val) {
        // 全选
        this.reset(true);
      } else {
        // 反全选
        this.reset(false);
      }
    },
    // 重置，flag: Boolean，全部重置为flag
    reset(flag) {
      this.titleData.forEach(item => {
        if (item.fixed != "left") {
          item.isShow = flag;
        }
      });
      this.showPopover();
      this.refreshTable();
    },
    // 表格列是否显示的方法
    showColumn(currentColumn) {
      if (!this.selectTitle) {
        return true;
      } else {
        return this.titleData.find(item => item.prop == currentColumn).isShow;
      }
    },
    /* 选择列 */
    changeColumns(val) {
      this.titleData.forEach(item => {
        item.isShow = false;
      });
      // columns将val数组存在的值设为true，不存在的设为false
      val?.forEach(item => {
        let current = this.titleData.find(i => i.label == item);
        current.isShow = true;
      });
      // 判断是否全选
      this.judgeIsCheckAll();
      this.refreshTable();
    },
    // 重新渲染表格
    refreshTable() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    // 气泡框出现
    showPopover() {
      this.checkColumns = [];
      this.titleData.forEach(item => {
        if (item.isShow) {
          this.checkColumns.push(item.label);
        }
      });
      // 判断是否全选
      this.judgeIsCheckAll();
    },
    // 判断是否全选
    judgeIsCheckAll() {
      // 选中的长度 = 表格列的长度  全选按钮就选中
      if (this.checkColumns.length == this.titleData.length)
        this.checkAll = true;
      else this.checkAll = false;
    },
    filterMethod(filters) {
      pubsub.publish("filter", filters); //发布消息
    },
    timeFormat(val) {
      return timeFormat(val);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      const  changeSize = this.changePageSize || 'changeSize'
      pubsub.publish(changeSize, val); //发布消息
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      // 获取props中的changePageCurrent
      const  changeCurrent = this.changePageCurrent || 'changeCurrent'
      pubsub.publish(changeCurrent, val); //发布消息
    },

        handleDialog(){
       this.$notify({
        title: "",
        dangerouslyUseHTMLString: true,
        position: "bottom-right",
        customClass: "help-center-notify",
        onClose: () => {
          this.showNotificationMask = false;
        },
        message: `<p class="notify-title" style="color">Q：为什么开票数量有是小数？</p>
        <p >
            A：货款类的提现金额是下级经销商的订货款转入代理商提现账户的钱，松鼠已经向经销商的订单开过销售发票了，因此这个货款再被提现出来，要根据原始的订单对应商品型号、单价、金额红冲发票或反向开销售发票给松鼠，根据本次申请提现的金额用到不同订单的货款，会生成对应不同金额的开票信息，金额、单价固定的情况下，数量就是小数了
            </p>
        `
      });
      this.showNotificationMask = true;
      this.$emit("handleDialog");
    },
    handleSelectionChange(selectionList) {
      // 使用 indexOf 方法查找对象在列表中的索引
      // const index = objectList.indexOf(targetObject);
      // 选中绑定的事件
      console.log(selectionList);
      this.multipleSelection = selectionList;
      if (this.needData == true) {
        this.$emit("selectTable", this.multipleSelection);
      }
    },
    // 取消选中
    handleClearSelection(row) {
      this.$refs.table.toggleRowSelection(row,false);
    },
    //全部取消选中
    handleClear(){
      this.$refs.table.clearSelection();
    },
    toggleRowSelection(row) {
      this.$refs.table.toggleRowSelection(row, true);
    },
    // handleSelect(selection, row) {
    //   console.log(selection, row);
    // },
    async handlePreviewOne(file) {
      window.open(file);
      // if (!file || file.length < 0) {
      //     file[0] = await getBase64(file.originFileObj);
      // }
      // this.setState({
      //     previewImageOne:  file[0] ,
      //     previewVisibleOne: true,
      //     isShow: false
      // });
    },
    cellClick(url, val, item, data) {
      if(item.pointType){
          trackEvent(item.pointType, {potentialPhone:data.sendPhone,potentialId:data.customId});
      }
      if (item.jump) {
        if (item.jump_type == "query") {
          if (item.jump_param) {
            let result = url + "?";
            for (let i = 0; i < item.jump_param.length; i++) {
              if (i == 0) {
                result =
                  result +
                  item.jump_param[i] +
                  "=" +
                  (data[item.jump_param[i]] || item.jump_param_default[i]);
              } else {
                result =
                  result +
                  "&" +
                  item.jump_param[i] +
                  "=" +
                  (data[item.jump_param[i]] || item.jump_param_default[i]);
              }
            }
            this.$router.push(result);
          } else {
            this.$router.push(url);
          }
        } else {
          if (item.jump_param) {
            let result = url;
            item.jump_param.forEach(e => {
              result = result + (data[e] ? "/" + data[e] : '');
            });
            console.log('%c result', 'color: red; font-size: 20px;', result);
            this.$router.push(result);
          } else {
            this.$router.push(url);
          }
        }
      } else {
        window.open(url + "?type=3&orderNo=" + val);
        // this.$router.push(url + "?type=3&orderNo=" + val);
      }
    },
    handleChangeNum(val) {
      if(!val){
        val = 0
      }
      this.$emit("handleNum", val);
    },
    onVisibleChangeFun(val) {
      if (this.mobileJustShow) {
        return;
      }

      this.phoneValChicks = "";
      console.log(val);
      getUserMobileById({ id: val.id }).then(ret => {
        if (ret.code === 0) {
          this.phoneValChicks = ret.data || "";
        }
      });
    },
    bindMobile() {
      this.$emit("bindMobile");
    },
    //tooltip的复制功能
    changeSnCopy(row) {
      let url = row;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;

      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success"
      });
      oInput.remove();
    },
    SetCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return { backgroundColor: "red !important" };
      } else {
        return { backgroundColor: "green !important" };
      }
    }
  },
  computed: {
    total() {
      return this.totalCount;
    }
  },
  mounted() {
    // this.doSearch();
    //切换小页面重置 page
    this.pubId1 = pubsub.subscribe("initPage", (_, data) => {
      console.log(this.fileName, data);
      if (this.fileName) {
        if (this.fileName == data) {
          // alert(111);
          this.currentPage = 1;
          this.pageSize = 10;
          this.handleSizeChange(10); //为了在对应组件中触发 search 方法
          this.handleCurrentChange(1);
        }
      }
    });
    //重新搜索，或者清空重置 page
    this.pubId2 = pubsub.subscribe("initPage2", (_, data) => {
      this.currentPage = 1;
      this.pageSize = 10;
      // this.handleSizeChange(10); //不需要触发，因为已经点击了 search
      // this.handleCurrentChange(1);
    });
  },
  beforeDestroy() {
    pubsub.unsubscribe(this.pubId); //取消订阅
  }
};
</script>
<style lang="scss">
.ellipsis-wrap{
  /* 限制为两行文字 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* 自适应文字大小 */
  -webkit-box-orient: vertical;
}
.el-table-filter__content {
  .el-scrollbar {
    height: 150px;
  }
}
.selectTitle {
  display: flex;
  flex-direction: column;
}
.districtsTooltip {
  min-width: 30px;
  min-height: 32px;
  padding: 6px 8px;
  color: #fff;
  text-align: left;
  text-decoration: none;
  word-wrap: break-word;
  border-radius: 4px;
}

.el-pagination {
  float: right;
}

.el-table__body {
  text-align: center;
}

.el-table {
  width: 100%;
  border: 1px solid #e2e4e5;
  border-radius: 5px;
  margin: 5px auto 20px !important;
  box-sizing: border-box;
}

.el-table thead {
  background: #1890ff !important;
}
.yellow-bg-row{
  background: #FFFBE8 !important;
}
.highlight-text-with-red{
  color: #f00;
}
.el-table__empty-block {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  padding-right: 100%;
}

.el-pagination {
  margin-right: 2.5%;
}

.rowName {
  color: #1890ff;
  cursor: pointer;
}

.btn-text {
  color: #4a83e8;
  cursor: pointer;
}

.el-table__row {
  height: 40px;
}

/* 去掉中间数据的分割线 */
.el-table__row td {
  border: none !important;
}

.custom-cell {
  .cell {
    white-space: nowrap !important;
    /* 确保文本在一行内 */
  }
}

.margin-left {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}
.hot{
  margin-right: 10px;
  color: #fff;
  background: #F43D3B;
  padding: 3px 5px;
  border-radius: 4px;
}
.notify-title{
  color: #426bca;
  margin-bottom: 15px !important;
}
.icon-kecheng::after{
  content: '\e6c9';
  font-family: element-icons;
  color: #32b6b9;
}
</style>
